var _g, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeviceCarAlarm01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M165.1,272.3c-10.9,0-19.7,9.3-18.7,20.5c0.9,9.7,9.3,17,19.1,17h180.1c9.8,0,18.2-7.3,19.1-17c1-11.1-7.8-20.5-18.7-20.5 H165.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.2,294.2L440,250c-1.4-10.3-10.9-17.4-21.2-16c-10.3,1.4-17.4,10.9-16,21.2l8.4,60c1.3,9.3,9.2,16.1,18.6,16.1h9.4 c9.8,0,18.2,7.3,19.1,17c1,11.1-7.8,20.5-18.7,20.5H72.7c-9.8,0-18.2-7.3-19.1-17c-1-11.1,7.8-20.5,18.7-20.5h9.9 c9.3,0,17.3-6.9,18.6-16.1l20.2-144c5.4-38.8,26.8-73.2,58.7-94.3c22.7-15.1,51-23,78.3-23c18.3,0.4,36.3,4,51.5,10.6 c9.5,4.1,20.5-0.2,24.7-9.7s-0.2-20.5-9.7-24.7c-19.8-8.6-43.3-13.3-66.5-13.7c-34.7,0-70.2,10.1-99,29.3 C118,72.7,90.7,116.6,83.7,166l-18,128.2c-29,3.3-51.4,28.9-49.7,59.1c1.6,29.2,27.7,53,56.9,53H439c29.2,0,55.3-23.8,56.9-53 C497.6,323.1,475.2,297.5,446.2,294.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.3,425.8c-10.3-1.2-19.6,6.2-20.8,16.5c-1.1,9.3-9.1,16.2-18.6,16.2c-9.5,0-17.5-7-18.6-16.2 c-1.2-10.3-10.5-17.7-20.8-16.5c-10.3,1.2-17.7,10.5-16.5,20.8c3.3,28.2,27.3,49.4,55.9,49.4c28.6,0,52.6-21.2,55.9-49.4 C314,436.3,306.6,427,296.3,425.8L296.3,425.8z"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 402.4,
    cy: 133.6,
    r: 61.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceCarAlarm01);
export default __webpack_public_path__ + "static/media/deviceCarAlarm-01.7b997b6d918dc31bdfadf65a496de568.svg";
export { ForwardRef as ReactComponent };